import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

/**
 * Componente che gestisce il callback di Auth0
 * Aspetta che Auth0 elabori il token e poi redirige alla home
 */
const AuthCallback = () => {
  const { isLoading, isAuthenticated, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    // Se il caricamento è finito, redirige
    if (!isLoading) {
      if (error) {
        console.error('❌ Auth0 callback error:', error);
        // In caso di errore, vai comunque alla home
        navigate('/', { replace: true });
      } else if (isAuthenticated) {
        console.log('✅ Auth0 callback: utente autenticato, redirect a /');
        navigate('/', { replace: true });
      } else {
        // Non autenticato, vai alla home (AuthGuard gestirà il login)
        console.log('⚠️ Auth0 callback: non autenticato, redirect a /');
        navigate('/', { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, error, navigate]);

  // Mostra loading mentre Auth0 processa il token
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      color: 'white',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        width: '60px',
        height: '60px',
        border: '4px solid rgba(255,255,255,0.1)',
        borderTop: '4px solid #00d4ff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '24px'
      }} />
      <style>
        {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
      </style>
      <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 600 }}>
        🔐 Autenticazione in corso...
      </h2>
      <p style={{ margin: '12px 0 0', opacity: 0.7, fontSize: '14px' }}>
        Stai per essere reindirizzato
      </p>
    </div>
  );
};

export default AuthCallback;

